"use client";
import { useEffect, useState } from "react";

const DevOverrideBanner = () => {
  const [hasOverrides, setHasOverrides] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== "development") return;

    // Monkey-patch fetch to detect overrides
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      const clone = response.clone();

      try {
        const data = await clone.json();
        const hasMarker = JSON.stringify(data).includes("__devtools_override");
        if (hasMarker) setHasOverrides(true);
      } catch {}

      return response;
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  if (!hasOverrides) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-50 -translate-y-1/2 rounded bg-yellow-500 px-4 py-2 text-black shadow-lg">
      ⚠️ DevTools overrides active
    </div>
  );
};

export default DevOverrideBanner;
